var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.state === "free"
    ? _c("span", { staticStyle: { width: "15px" } })
    : _c(
        "div",
        {
          staticClass: "splicing-icon-container",
          style: { width: "15px", height: "15px" }
        },
        [
          _c(
            "v-icon",
            {
              class: _vm.className,
              style: {
                transform: _vm.state === "split" ? "rotate(180deg)" : "unset",
                color: _vm.color ? _vm.color : null
              },
              attrs: { size: _vm.size }
            },
            [_vm._v("\n    " + _vm._s(_vm.icon) + "\n  ")]
          )
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7a200d2a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a200d2a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Forms/_SpecialTabs/Splicing/ObjectTable/ConnectionPointConnectionIcon.vue
// module id = null
// module chunks = 